import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { ContentSwitch, ConfirmModal, ConfirmDelete, JobsImportedModal, ConfirmAccessModal } from 'Components';
import { Link } from 'react-router-dom';
import { confirmJobsStatus, confirmSuppliesStatus } from 'helpers/confirmStatus';
import DownloadFromUrl from 'helpers/download';
import Fetch from 'helpers/fetch';
import { copy } from 'helpers/deep';
import { SUBMISSIONS, TEMPLATES, SUPPLIES, TEMPLATE_TO_EXCEL, INVOICES } from 'constants/apis';
import menuOptions from 'constants/menuOptions';
import rowRules from 'helpers/rowRules';
import OverviewDesktop from './OverviewDesktop/OverviewDesktop';
import OverviewMobile from './OverviewMobile/OverviewMobile';

const placeholderDescription = (input, href) => (
  <p>{i18n.t('overview:There are currently no')} {input}s {i18n.t('overview:available')}
    {i18n.t('overview:If you’d like to create a new')} {input},
    {i18n.t('overview:please click')} {<Link to={href}> {i18n.t('overview:New')} {input[0].toUpperCase() + input.substr(1)}</Link>}.
  </p>);

const InvoiceDescription = (hasAccessToInvoices) => {
  const hasAccess = hasAccessToInvoices;
  let description;
  if (hasAccess) {
    description = (
      <p>{i18n.t('overview:noInvoices')}
        {i18n.t('overview:If you need assistance, please contact your Bureau Veritas representative&#46;')}
      </p>);
  } else {
    description = (<p>{i18n.t('overview:For access to invoices, please contact your Bureau Veritas representative&#46;')}</p>);
  }
  return description;
};

class Overview extends React.Component {
  constructor(props) {
    super(props);
 
    this.state = {
      powerTableIndex: null,
      powerTableViewCode: null,
      auditTrailItem: '',
      isAuditTrailItemShowing: false,
      deleteItemCategory: null,
      isShowDeleteConfirmation: false,
      itemToDelete: undefined,
      showAccessConfirmation: false,
      itemToCancelIndex: undefined,
      cancelItemComments: '',
    };

    this.setPageState = this.setPageState.bind(this);
    this.onOptionClick = this.onOptionClick.bind(this);
    this.onPinClick = this.onPinClick.bind(this);
    this.onAuditCancel = this.onAuditCancel.bind(this);
    this.onAuditProceed = this.onAuditProceed.bind(this);
    this.onOptionClickInvoice = this.onOptionClickInvoice.bind(this);
    this.handleCancelDelete = this.handleCancelDelete.bind(this);
    this.handleProceedDelete = this.handleProceedDelete.bind(this);
    this.deleteSubmission = this.deleteSubmission.bind(this);
    this.deleteTemplate = this.deleteTemplate.bind(this);
    this.deleteSupply = this.deleteSupply.bind(this);
    this.handleCloseAndProceed = this.handleCloseAndProceed.bind(this);
  }

  
  componentDidMount() {
   
    this.props.setHeadTitle(i18n.t('overview:Recent Activity'));

    this.props.setAppState(prevState => ({
      overviewJobs: {
        ...prevState.overviewJobs,
        shouldLoad: true,
      },
      overviewTemplates: {
        ...prevState.overviewTemplates,
        shouldLoad: true,
      },
      overviewInvoices: {
        ...prevState.overviewInvoices,
        shouldLoad: true,
      },
      overviewOrders: {
        ...prevState.overviewOrders,
        shouldLoad: true,
      },
    }));
     //Variable to allow displaying the message one time only on login
    //This variable is removed on logout
    const messageShown = localStorage.getItem("messageShown");
    if (!this.props.IsInternalUser && this.props.isFoodUser && !messageShown) {
      this.setState({ showAccessConfirmation: true });
   
    }
   }

  componentDidUpdate(prevProps) {
    if ((this.props.location !== prevProps.location)
    || (prevProps.filterItemValue !== this.props.filterItemValue)) {
      this.props.setHeadTitle(i18n.t('overview:Recent Activity'));
    }
  }

  componentWillUnmount() {
    this.props.templatesData.abortController.abort();
    this.props.jobsData.abortController.abort();
    this.props.invoicesData.abortController.abort();
    this.props.ordersData.abortController.abort();

    this.props.setAppState(prevState => ({
      overviewTemplates: {
        ...prevState.overviewTemplates,
        abortController: new AbortController(),
      },
      overviewJobs: {
        ...prevState.overviewJobs,
        abortController: new AbortController(),
      },
      overviewOrders: {
        ...prevState.overviewOrders,
        abortController: new AbortController(),
      },
      overviewInvoices: {
        ...prevState.overviewInvoices,
        abortController: new AbortController(),
      },
    }));
  }

  onAuditCancel() {
    this.setState({ auditTrailItem: undefined });
    this.props.setAppState({ ChangeLogComments: '' });
  }

  onAuditProceed() {
    const Id = this.state.auditTrailItem.SubmissionId;
    this.setState({ isAuditTrailItemShowing: false }, () =>
      this.props.setAppState({ isChangingObject: true }));

      Fetch.Put(`${SUBMISSIONS}/${Id}/Edit`)
      .then(() => this.props.history.push(`/submissions/${Id}/edit`))
      .then(() => this.props.setAppState({ isChangingObject: false, formIndex: 0 }));
  }

  onOptionClick(code, i) {
    this.setState({ powerTableIndex: null });
    if (this.state.powerTableViewCode === 'overviewTemplates') this.onOptionClickTemplate(code, i);
    if (this.state.powerTableViewCode === 'overviewJobs') this.onOptionClickJob(code, i);
    if (this.state.powerTableViewCode === 'overviewOrders') this.onOptionClickOrder(code, i);
    if (this.state.powerTableViewCode === 'overviewInvoices') this.onOptionClickInvoice(code, i);
  }

  onOptionClickInvoice(code, tableIndex) {
    if (code === 'pay') {
      this.props.setAppState(prevState => ({
        invoices: {
          ...prevState.invoices,
          paySingleInvoice: true,
          singlePayInvoiceNumber: this.props.invoicesData.data[tableIndex].InvoiceNumber,
        },
      }), () => this.props.history.push('/invoices/payment-summary'));
    }

    if (code === 'view') {
      let url = `${INVOICES}/${this.props.invoicesData.data[tableIndex].InvoiceNumber}/DownloadInvoice?`;
      if (this.props.IsInternalUser) url = url.concat(`clientNumber=${this.props.clientNumber}`);
      DownloadFromUrl(url)
        .catch(({ response }) => this.props.onAPIError(response, true));
    }
  }

  handleCloseAndProceed() {
    localStorage.setItem('messageShown', 'true')
    this.setState({showAccessConfirmation: false });
  }

  onOptionClickTemplate(code, i) {
    const item = this.props.templatesData.data[i];

    switch (code) {
      case 'edit':
        this.props.history.push(`/templates/${item.Id}/edit`);
        break;
      case 'delete':
        this.setState({
          deleteItemCategory: 'Template',
          itemToDelete: item,
          isShowDeleteConfirmation: true,
        });
        break;
      case 'copy':
        Fetch.Post(TEMPLATES, { CopyTemplateId: item.Id })
          .then(resp => resp.json())
          .then(data => this.props.history.push(`/templates/${data.DataItem.Id}/edit`));
        break;
      case 'newSubmission':
        this.props.setAppState({ isCreatingObject: true });
        Fetch.Post(`${SUBMISSIONS}/Template/${item.Id}`)
          .then(data => data.json())
          .then(json => this.props.history.push(`/submissions/${json.DataItem.Id}/edit`))
          .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: this.props.isPrepaid ? 0 : 2 }))
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
        break;
      case 'newOrder':
        this.props.setAppState({ isCreatingObject: true });
        if (this.props.isPrepaid) {
          Fetch.Post(`${SUBMISSIONS}/Template/${item.Id}?requireOrder=true`)
            .then(data => data.json())
            .then(json => this.props.history.push(`/submissions/${json.DataItem.Id}/edit`))
            .then(() => this.props.setAppState({ isCreatingObject: false, isPrepaidOrder:true, formIndex: this.props.isPrepaid ? 0 : 2 }))
            .catch(({ response }) => this.props.onAPIError(response, true))
            .finally(() => this.props.setAppState({ isCreatingObject: false }));
        } else {
          Fetch.Post(SUPPLIES, { CopyTemplateId: item.Id })
            .then(data => data.json())
            .then(data => this.props.setAppState({
              isCreatingObject: false,
              formIndex: 0,
            }, () => this.props.history.push(`/supplies/${data.DataItem.OrderNumber}/edit`)))
            .catch(({ response }) => this.props.onAPIError(response, true))
            .finally(() => this.props.setAppState({ isCreatingObject: false }));
        }
        break;
      case 'share':
        this.props.setAppState({ shareId: item.Id, shareCode: 'Template' });
        break;
      case 'excel':
        DownloadFromUrl(`${TEMPLATE_TO_EXCEL}/${item.Id}`);
        break;
      default:
        break;
    }
  }

  onOptionClickJob(code, i) {
    const item = this.props.jobsData.data[i];
    const isJob = !!item.MaxxamJobNumber;
    const copyBody = isJob
      ? { CopyMaxxamJobNumber: item.MaxxamJobNumber }
      : { CopySubmissionId: item.SubmissionId };

    if (code === 'view' && !isJob) {
      confirmJobsStatus(item)
        .then(() => {
          if (item.Status === 'S') {
            this.props.setAppState({ formIndex: 4 });
          } else {
            this.props.setAppState({ formIndex: 2 });
          }

          this.props.history.push(`/submissions/${encodeURIComponent(item.SubmissionId)}/edit`);
        })
        .catch(() => this.refreshTable('overviewJobs'));
    } else if (code === 'view' && isJob) {
      this.props.history.push(`/jobs/${encodeURIComponent(item.MaxxamJobNumber)}`);
    } else if (code === 'edit' && !isJob) {
      confirmJobsStatus(item)
        .then(() => {
          if (item.Status === 'S' || item.Status === 'E' || item.Status === 'C') {
            this.setState({ auditTrailItem: item, isAuditTrailItemShowing: true });
          } else {
            this.props.setAppState({ formIndex: 0 });
            this.props.history.push(`/submissions/${encodeURIComponent(item.SubmissionId)}/edit`);
          }
        })
        .catch(() => this.refreshTable('overviewJobs'));
    } else if (code === 'newTemplate') {
      this.props.setAppState({ isCreatingObject: true });

      Fetch.Post(TEMPLATES, copyBody)
        .then(data => data.json())
        .then(json => this.props.history.push(`/templates/${json.DataItem.Id}/edit`))
        .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: 0 }))
        .catch(({ response }) => this.props.onAPIError(response, true))
        .finally(() => this.props.setAppState({ isCreatingObject: false }));
    } else if (code === 'newSubmission') {
      this.props.setAppState({ isCreatingObject: true });
      const url = isJob ? `${SUBMISSIONS}/Job/${item.MaxxamJobNumber}` :
        `${SUBMISSIONS}/submission/${item.SubmissionId}`;
      Fetch.Post(url)
        .then(data => data.json())
        .then(json => this.props.history.push(`/submissions/${json.DataItem.Id}/edit`))
        .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: 0 }))
        .catch(({ response }) => this.props.onAPIError(response, true))
        .finally(() => this.props.setAppState({ isCreatingObject: false }));
    } else if (code === 'newOrder') {
      this.props.setAppState({ isCreatingObject: true });
      if (this.props.isPrepaid) {
        const url = isJob ? `${SUBMISSIONS}/Job/${item.MaxxamJobNumber}?requireOrder=true` :
          `${SUBMISSIONS}/submission/${item.SubmissionId}?requireOrder=true`;
        Fetch.Post(url)
          .then(data => data.json())
          .then(json => this.props.history.push(`/submissions/${json.DataItem.Id}/edit`))
          .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: 0,isPrepaidOrder:true }))
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
      }
      else {
        Fetch.Post(SUPPLIES, copyBody)
          .then(data => data.json())
          .then(json => this.props.history.push(`/supplies/${json.DataItem.OrderNumber}/edit`))
          .then(() => this.props.setAppState({ isCreatingObject: false, formIndex: 0 }))
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
      }
    } else if (code === 'delete' && !isJob) {
      confirmJobsStatus(item)
        .then(() => {
          if (item.Status === 'D' || item.Status === 'C') {
            this.setState({
              deleteItemCategory: 'Submission',
              itemToDelete: item,
              isShowDeleteConfirmation: true,
            });
          }
        })
        .catch(() => this.refreshTable('overviewJobs'));
    } else if (code === 'cancel') {
      if (this.state.itemToCancelIndex !== undefined) {
        confirmJobsStatus(item)
          .then(() => {
            this.props.setAppState({ isChangingObject: true });
            this.setState({ itemToCancelIndex: undefined });
            Fetch.Put(`${SUBMISSIONS}/${item.SubmissionId}/Cancel`,
              this.state.cancelItemComments
            ).then(() => {
                this.setState({ cancelItemComments: '' });
                this.props.setAppState(prevState => ({
                  isChangingObject: false,
                  overviewJobs: {
                    ...prevState.overviewJobs,
                    shouldLoad: true,
                  },
                }));
              });
          })
          .catch(() => this.refreshTable('overviewJobs'));
      } else {
        this.setState({ itemToCancelIndex: i, cancelItemComments: '' });
      }
    } else if (code === 'share') {
      if (isJob) {
        this.props.setAppState({ shareId: item.MaxxamJobNumber, shareCode: 'Job' });
      } else {
        this.props.setAppState({ shareId: item.SubmissionId, shareCode: 'Submission' });
      }
    } else if (code === 'trackingForm') {
      DownloadFromUrl(`${SUBMISSIONS}/${item.SubmissionId}/GetPhysicalTrackingForm`);
    } else if (code === 'submissionSummary') {
      DownloadFromUrl(`${SUBMISSIONS}/${item.SubmissionId}/GetGenericPDF?SummaryFormat=true`);
    } else if (code === 'submissionDetails') {
      DownloadFromUrl(`${SUBMISSIONS}/${item.SubmissionId}/GetGenericPDF?SummaryFormat=false`);
    }
  }


  // Supplies table:
  onOptionClickOrder(code, i) {
    const item = this.props.ordersData.data[i];

    switch (code) {
      case 'view':
        confirmSuppliesStatus(item)
          .then(() => {
            if (item.Status === '-2') {
              this.props.setAppState({
                formIndex: 2,
              }, this.props.history.push(`/supplies/${encodeURIComponent(item.OrderNumber)}/edit`));
            } else {
              DownloadFromUrl(`${SUPPLIES}/${item.OrderNumber}/GetConfirmationPDF`);
            }
          })
          .catch(() => this.refreshTable());

        break;
      case 'edit':
        this.props.setAppState({
          formIndex: 0,
        }, this.props.history.push(`/supplies/${encodeURIComponent(item.OrderNumber)}/edit`));
        break;
      case 'copy':
        this.props.setAppState({ isCreatingObject: true });
        if (this.props.isPrepaid)
        {
          Fetch.Post(`${SUBMISSIONS}/Order/${item.OrderNumber}?requireOrder=true`)
            .then(resp => resp.json())
            .then(data => this.props.history.push(`/submissions/${data.DataItem.Id}/edit`))
            .then(() => this.props.setAppState({ formIndex: 0 ,isPrepaidOrder:true}))
            .finally(() => this.props.setAppState({ isCreatingObject: false }));
        }
        else {
          Fetch.Post(`${SUPPLIES}/${item.OrderNumber}/CopyOrder`)
            .then(resp => resp.json())
            .then(data => this.props.history.push(`/supplies/${data.DataItem.OrderNumber}/edit`))
            .finally(() => this.props.setAppState({ isCreatingObject: false }));
        }
        break;
      case 'newTemplate':
        this.props.setAppState({ isCreatingObject: true });
        Fetch.Post(TEMPLATES, { CopyOrderNumber: item.OrderNumber })
          .then(resp => resp.json())
          .then(data => this.props.history.push(`/templates/${data.DataItem.Id}/edit`))
          .then(() => this.props.setAppState({ formIndex: 0 }))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
        break;
      case 'newSubmission':
        this.props.setAppState({ isCreatingObject: true });
        Fetch.Post(`${SUBMISSIONS}/Order/${item.OrderNumber}`)
          .then(resp => resp.json())
          .then(data => this.props.history.push(`/submissions/${data.DataItem.Id}/edit`))
          .then(() => this.props.setAppState({ formIndex: 0 }))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
        break;
      case 'cancel':
        this.props.setAppState({ isChangingObject: true });
        Fetch.Post(`${SUPPLIES}/${item.OrderNumber}/cancel`)
          .then(() => this.props.setAppState(prevState => ({
            overviewOrders: {
              ...prevState.overviewOrders,
              shouldLoad: true,
            },
          })))
          .finally(() => this.props.setAppState({ isChangingObject: false }));
        break;
      case 'delete':
        this.props.setAppState(prevState => ({
          overviewOrders: {
            ...prevState.overviewOrders,
            isDeleting: true,
          },
        }));
        // OLD:
        // Fetch.Delete(`${SUPPLIES}/${item.OrderNumber}`)
        this.setState(prevState => ({
          ...prevState,
          itemToDelete: item,
          deleteItemCategory: "Supply",
          isShowDeleteConfirmation: true
        }))
        
        // Fetch.Delete(SUPPLIES, { IdList: [item.OrderNumber] })
        //   .then(() => {
        //     this.props.setAppState(prevState => ({
        //       overviewOrders: {
        //         ...prevState.overviewOrders,
        //         shouldLoad: true,
        //         isDeleting: false,
        //       },
        //     }));
        //   })
        //   .catch(({ response }) => this.props.onAPIError(response, true))
        //   .finally(() => this.props.setAppState(prevState => ({
        //     overviewOrders: {
        //       ...prevState.overviewOrders,
        //       isDeleting: false,
        //     },
        //   })));
        break;
      case 'share':
        this.props.setAppState({ shareId: item.OrderNumber, shareCode: 'Order' });
        break;
      default:
        break;
    }
  }

  onPinClick(i, viewCode) {
    if (viewCode === 'overviewTemplates') this.onPinClickTemplate(i);
    if (viewCode === 'overviewOrders') this.onPinClickOrder(i);
  }

  onPinClickTemplate(index) {
    const overviewTemplates = {
      ...copy(this.props.templatesData),
      abortController: new AbortController(),
    };
    const selectedTemplate = overviewTemplates.data[index];
    const path = selectedTemplate.Pinned ? 'Unpin' : 'Pin';

    overviewTemplates.data[index].Pinned = !overviewTemplates.data[index].Pinned;
    this.props.setAppState({ overviewTemplates });
    Fetch.Post(`${TEMPLATES}/${selectedTemplate.Id}/${path}`);
  }

  onPinClickOrder(index) {
    const overviewOrders = {
      ...copy(this.props.ordersData),
      abortController: new AbortController(),
    };
    const selectedSupplies = overviewOrders.data[index];
    const path = selectedSupplies.Pinned ? 'Unpin' : 'Pin';

    overviewOrders.data[index].Pinned = !overviewOrders.data[index].Pinned;
    this.props.setAppState({ overviewOrders });
    Fetch.Post(`${SUPPLIES}/${selectedSupplies.OrderNumber}/${path}`);
  }

  setPageState(state, callback) {
    if (Number.isInteger(state.powerTableIndex) && state.powerTableViewCode === 'overviewJobs') {
      if ((this.props.jobsData.data[state.powerTableIndex] || {}).Status === 'I') {
        this.setState({ isShowingImportedJobModal: true });
      } else {
        this.setState(state, callback);
      }
    } else {
      this.setState(state, callback);
    }
  }

  handleCancelDelete() {
    this.setState({
      deleteItemCategory: null,
      itemToDelete: undefined,
      isShowDeleteConfirmation: false,
    });
  }

  handleProceedDelete() {
    const { deleteItemCategory, itemToDelete } = this.state;
    switch (deleteItemCategory) {
      case 'Template':
        this.deleteTemplate(itemToDelete);
        break;
      case 'Submission':
        this.deleteSubmission(itemToDelete);
        break;
      case 'Supply':
        this.deleteSupply(itemToDelete);
        break;
      default:
        return false;
    }

    return this.setState({
      deleteItemCategory: null,
      itemToDelete: undefined,
      isShowDeleteConfirmation: false,
    });
  }

deleteSupply(item){
  Fetch.Delete(SUPPLIES, { IdList: [item.OrderNumber] })
          .then(() => {
            this.props.setAppState(prevState => ({
              overviewOrders: {
                ...prevState.overviewOrders,
                shouldLoad: true,
                isDeleting: false,
              },
            }));
          })
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState(prevState => ({
            overviewOrders: {
              ...prevState.overviewOrders,
              isDeleting: false,
            },
          })));
}

  deleteTemplate(item) {
    this.props.setAppState(prevState => ({
      overviewTemplates: {
        ...prevState.overviewTemplates,
        isLoading: true,
      },
    }));

    Fetch.Delete(TEMPLATES, { IdList: [item.Id] })
      .then(() => this.props.setAppState(prevState => ({
        overviewTemplates: {
          ...prevState.overviewTemplates,
          shouldLoad: true,
        },
      })))
      .catch(({ response }) => this.props.onAPIError(response, true))
      .finally(() => this.props.setAppState(prevState => ({
        overviewTemplates: {
          ...prevState.overviewTemplates,
          isLoading: false,
        },
      })));
  }

  deleteSubmission(item) {
    this.props.setAppState(prevState => ({
      overviewJobs: {
        ...prevState.overviewJobs,
        isLoading: true,
      },
    }));

    this.setState({
      powerTableIndex: null,
      popoverRow: null,
    });

    Fetch.Delete(SUBMISSIONS, { IdList: [item.SubmissionId] })
      .then(() => {
        this.props.setAppState(prevState => ({
          overviewJobs: {
            ...prevState.overviewJobs,
            shouldLoad: true,
          },
        }));
      })
      .catch(({ response }) => this.props.onAPIError(response, true))
      .finally(() => {
        this.props.setAppState(prevState => ({
          overviewJobs: {
            ...prevState.overviewJobs,
            isDeleting: false,
          },
        }));
      });
  }

  refreshTable(table) {
    this.props.setAppState(prevState => ({
      [table]: {
        ...prevState[table],
        shouldLoad: true,
      },
    }));
  }

  render() {
    const { state, props } = this;
    const sharedProps = {
      placeholderDescription,
      InvoiceDescription: InvoiceDescription(props.hasAccessToInvoices),
      rowRules,
      setPageState: this.setPageState,
      menuOptions,
      onOptionClick: this.onOptionClick,
      onPinClick: this.onPinClick,
    };

    return (
      <Fragment>
        <ContentSwitch index={props.deviceIndex} {...state} {...props} {...sharedProps}>
          <OverviewMobile />
          <OverviewDesktop />
        </ContentSwitch>
        {state.showAccessConfirmation &&
          <ConfirmAccessModal
          messageLine1={i18n.t('confirmModal:confirmAccessLine1')}
          messageLine2={i18n.t('confirmModal:confirmAccessLine2')}
          link={i18n.t('confirmModal:accessLink')}
          url={i18n.t('confirmModal:accessWebSiteUrl')}
          onProceedClick={this.handleCloseAndProceed}
          />
        }
        { state.auditTrailItem && state.isAuditTrailItemShowing &&
        <ConfirmModal
          onChange={e => props.setAppState({ ChangeLogComments: e.target.value })}
          value={props.ChangeLogComments}
          description={i18n.t('confirmModal:edit')}
          cancelReasonText={i18n.t('confirmModal:reason')}
          onCancelClick={this.onAuditCancel}
          onProceedClick={() => this.onAuditProceed(state.auditTrailItem)}
        />
        }
        { state.itemToCancelIndex !== undefined &&
        <ConfirmModal
          onChange={e => this.setState({ cancelItemComments: e.target.value })}
          value={state.cancelItemComments}
          description={i18n.t('confirmModal:cancel')}
          cancelReasonText={i18n.t('confirmModal:reason')}
          onCancelClick={() => this.setState({ cancelItemComments: '', itemToCancelIndex: undefined })}
          onProceedClick={() => this.onOptionClickJob('cancel', this.state.itemToCancelIndex)}
        />
        }
        { state.isShowingImportedJobModal &&
          <JobsImportedModal setPageState={this.setPageState} />
        }
        { state.isShowDeleteConfirmation &&
          <ConfirmDelete
            title={`${i18n.t('common:Delete the')} ${i18n.t(`common:${this.state.deleteItemCategory}`)}`}
            onCancelDelete={this.handleCancelDelete}
            onProceedDelete={this.handleProceedDelete}
          />
        }
      </Fragment>
    );
  }
}

Overview.propTypes = {
  setAppState: PropTypes.func,
  ordersData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    abortController: PropTypes.shape({
      abort: PropTypes.func,
    }),
  }),
  templatesData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    abortController: PropTypes.shape({
      abort: PropTypes.func,
    }),
  }),
  jobsData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({})),
    abortController: PropTypes.shape({
      abort: PropTypes.func,
    }),
  }),
  clientNumber: PropTypes.string,
  invoicesData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      InvoiceNumber: PropTypes.string,
    })),
    abortController: PropTypes.shape({
      abort: PropTypes.func,
    }),
  }),
  setHeadTitle: PropTypes.func,
  filterItemValue: PropTypes.string,
  location: PropTypes.shape({}),
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  IsInternalUser: PropTypes.bool,
  onAPIError: PropTypes.func,
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  isPrepaid: PropTypes.bool,
  isFoodUser: PropTypes.bool,
};

export default Overview;



// WEBPACK FOOTER //
// ./src/containers/Overview/Overview.jsx